import type { Props as DatePickerProps } from 'components/datepicker/DatePicker';
import Tooltip from 'components/Tooltip';
import { DateTime } from 'luxon';
import React from 'react';
import { LocaleUtils } from 'react-day-picker';
import type { StartOfWeek } from '../../types/account';
import styles from './DatePickerHeader.module.scss';

interface WeekdaysProps {
  firstDayOfWeek?: StartOfWeek;
}

const Weekdays = (props: WeekdaysProps) => {
  const { firstDayOfWeek = 1 } = props;

  const renderDays = () => {
    const days: Array<React.ReactElement> = [];

    // Empty placeholder to align with the week number column (no label)
    days.push(<div key="week-number" className={styles.weekday} aria-hidden="true" />);

    for (let i = 0; i < 7; i += 1) {
      const weekday = (i + firstDayOfWeek) % 7;

      const weekdayName = LocaleUtils.formatWeekdayLong(weekday); // locale missing

      days.push(
        <div key={i} className={styles.weekday} title={weekdayName}>
          {/* {weekday}  */}
          <Tooltip title={weekdayName}>{weekdayName.slice(0, 1)}</Tooltip>
        </div>
      );
    }
    return <>{days}</>;
  };
  return (
    <div className={styles.weekdays} role="rowgroup">
      <div className={styles.weekdaysRow} role="row">
        {renderDays()}
      </div>
    </div>
  );
};
interface Props extends Pick<DatePickerProps, 'baseDate' | 'startOfWeek'> {
  onYearChange: (date: string) => void;
  selectedYear: string;
  showRelativeDateRanges: boolean;
}

const DatePickerHeader: React.FC<Props> = ({
  startOfWeek,
  onYearChange,
  selectedYear,
  showRelativeDateRanges,
}) => {
  const length = 30;
  const startingPoint = DateTime.now().plus({ years: length / 2 });

  return (
    <div
      className={styles.container}
      style={
        showRelativeDateRanges
          ? {
              width: 375,
              borderRight: '1px solid var(--theme_color_content_divider)',
            }
          : undefined
      }
    >
      <div className={styles.selectWrap}>
        <Tooltip title="Choose year">
          <div className={styles.select}>
            <select
              id="year"
              name="year"
              value={selectedYear}
              onChange={o => onYearChange(o.target.value)}
            >
              {Array.from({ length })
                .map((v, i) => {
                  const currentYear = startingPoint.minus({ years: i });
                  const formatted = currentYear.toFormat('y');
                  return (
                    <option key={i} value={formatted}>
                      {currentYear.toFormat('y')}
                    </option>
                  );
                })
                .reverse()}
            </select>
            <span className={styles.focus} />
          </div>
        </Tooltip>
      </div>

      <Weekdays firstDayOfWeek={startOfWeek} />
    </div>
  );
};

export default DatePickerHeader;
